import { qs, qsa, add, remove } from "@fluorescent/dom";
import { delayOffset } from "@/lib/animation";

const selectors = {
  menuPrimary: ".drawer-menu__primary-links",
  subMenus: ".drawer-menu__list--sub",
  menuFooter: ".drawer-menu__footer",
  animationItem: ".animation--drawer-menu-item",
};

const classes = {
  animationRevealed: "animation--drawer-menu-revealed",
};

export default node => {
  const primaryMenu = qs(selectors.menuPrimary, node);
  const primaryMenuDirectLinks = qsa(
    `${selectors.menuPrimary} > ${selectors.animationItem}`
  );
  delayOffset(primaryMenu, [`:scope > ${selectors.animationItem}`]);

  const subMenus = qsa(selectors.subMenus, node);

  subMenus.forEach(menu => {
    delayOffset(menu, [`:scope > ${selectors.animationItem}`]);
  });

  const footerMenu = qs(selectors.menuFooter);

  if (footerMenu) {
    delayOffset(
      footerMenu,
      [
        `:scope > ${selectors.animationItem}`,
        `:scope  .drawer-menu__form > ${selectors.animationItem}`,
      ],
      primaryMenuDirectLinks.length
    );
  }

  // Trigger the reveal animation on primary links when the drawer is opened
  function openMain(node) {
    add(node, classes.animationRevealed);
  }
  // Trigger the reveal animation on se;ected sub links when opened
  function openSub(menu) {
    add(menu, classes.animationRevealed);
  }

  return {
    openMain,
    openSub,
  };
};
